import { BaseCard } from "./BaseCard.js";
import { CardHeader } from "./internal/CardHeader.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/OutlinedCard.tsx
const OutlinedCard = ({ children, footer, header, Icon, iconColor, iconBackground, onClick, role, shadow, padding = "sm", sharp = false, style, "data-testid": testId, fullWidthFooter = false, pinFooter, fullHeight }) => {
	return /* @__PURE__ */ jsx(BaseCard, {
		onClick,
		withBorder: true,
		footer,
		fullWidthFooter,
		pinFooter,
		fullHeight,
		header: header ? /* @__PURE__ */ jsx(CardHeader, { children: header }) : null,
		Icon,
		iconColor,
		iconBackground,
		variant: "filled",
		padding,
		radius: sharp ? "0" : "sm",
		"data-testid": testId,
		style: {
			borderColor: `var(--mantine-color-gray-2)`,
			...style
		},
		role,
		shadow,
		children
	});
};

//#endregion
export { OutlinedCard };